import React from "react";
// import { useDispatch } from 'react-redux'
import { useNavigate } from "react-router-dom";
// import { logoutUser } from '../feature/auth/AuthActions'
import { TopNavContainer, TopNavPageName } from "./TopNav.styled";
import Logo from "../assets/pubmining_logo.png";
import { useSelector } from "react-redux";

const TopNav = () => {
  // const dispatch = useDispatch()
  const navigate = useNavigate();
  const { userNotifications } = useSelector((state) => state.notification);
  const { user } = useSelector((state) => state.user);

  return (
    <TopNavContainer>
      {window.location.pathname === "/" ? (
        <div style={{ cursor: "pointer" }}>
          <img src={Logo} alt="logo" />
        </div>
      ) : (
        <svg
          style={{
            cursor: "pointer",
            position: "absolute",
          }}
          onClick={() => navigate(-1)}
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M28.0606 14.9393C28.6464 15.5251 28.6464 16.4749 28.0606 17.0607L21.1214 24L28.0606 30.9394C28.6464 31.5252 28.6464 32.4748 28.0606 33.0606C27.4748 33.6464 26.5252 33.6464 25.9394 33.0606L17.9393 25.0606C17.3536 24.4748 17.3536 23.5252 17.9393 22.9394L25.9394 14.9393C26.5252 14.3536 27.4748 14.3536 28.0606 14.9393Z"
            fill="white"
          />
        </svg>
      )}
      <TopNavPageName>
        {window.location.pathname !== "/" &&
          window.location.pathname.slice(1).replace("-", " ").toUpperCase()}
      </TopNavPageName>
      {window.location.pathname === "/" && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            color: "#fff",
            cursor: "pointer",
          }}
          onClick={() => navigate("/notifications")}
        >
          <div>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.0002 3C13.0002 2.44772 12.5525 2 12.0002 2C11.4479 2 11.0002 2.44772 11.0002 3V3.75H10.4428C8.2177 3.75 6.3761 5.48001 6.23721 7.70074L6.0162 11.2342C5.93194 12.5814 5.47965 13.8797 4.70859 14.9876C4.01191 15.9886 4.63213 17.3712 5.84306 17.5165L9.25019 17.9254V19C9.25019 20.5188 10.4814 21.75 12.0002 21.75C13.519 21.75 14.7502 20.5188 14.7502 19V17.9254L18.1573 17.5165C19.3683 17.3712 19.9885 15.9886 19.2918 14.9876C18.5207 13.8797 18.0684 12.5814 17.9842 11.2342L17.7632 7.70074C17.6243 5.48001 15.7827 3.75 13.5576 3.75H13.0002V3ZM10.4428 5.25C9.00977 5.25 7.82373 6.36417 7.73428 7.79438L7.51328 11.3278C7.41188 12.949 6.86763 14.5112 5.93978 15.8444C5.88943 15.9168 5.93425 16.0167 6.02178 16.0272L9.75944 16.4757C11.2479 16.6543 12.7525 16.6543 14.2409 16.4757L17.9786 16.0272C18.0661 16.0167 18.111 15.9168 18.0606 15.8444C17.1328 14.5112 16.5885 12.949 16.4871 11.3278L16.2661 7.79438C16.1766 6.36417 14.9906 5.25 13.5576 5.25H10.4428ZM12.0002 20.25C11.3098 20.25 10.7502 19.6904 10.7502 19V18.25H13.2502V19C13.2502 19.6904 12.6906 20.25 12.0002 20.25Z"
                fill="white"
              />
              {userNotifications.filter(
                (notification) =>
                  notification.is_read === false &&
                  notification.user === user.id
              ).length && <circle cx="7" cy="7" r="5" fill="#FF0000" />}
            </svg>
          </div>
          <div style={{ fontSize: "10px" }}>Notification</div>
        </div>
      )}
    </TopNavContainer>
  );
};

export default TopNav;
